import ScrollRow from "@components/layout/ScrollRow";
import pattern from "@svg/pattern3.svg";
import { Link } from "react-router-dom";
import PlayIcon from "@components/media/PlayIcon";

function ForYouLeadCard() {
  return (
    <div className="relative h-[471px] w-[577px] shrink-0 overflow-hidden rounded-xl">
      <div
        className="for-you-angled-card relative h-full w-full overflow-hidden bg-cover bg-center"
        style={{
          backgroundImage: `url(${pattern})`,
        }}
      >
        <div className="absolute left-0 top-[0.2px] h-[470.55px] w-[577px] bg-[radial-gradient(44.53%_44.53%_at_50%_32.96%,rgba(0,0,0,0)_0%,rgba(0,0,0,0.4)_100%)]" />

        <div className="absolute left-[413px] top-[305px] h-[274px] w-[274px] rounded-full bg-[#354BCA] blur-[196.15px] mix-blend-plus-lighter" />
        <div className="absolute left-[478px] top-[336px] h-[220px] w-[220px] rounded-full bg-[#354BCA] blur-[196.15px] mix-blend-plus-lighter" />
        <div className="absolute left-[27px] top-[399px] h-[200px] w-[200px] rounded-full bg-[#354BCA] blur-[196.15px] mix-blend-plus-lighter" />
        <div className="absolute left-[-82px] top-[435px] h-[258px] w-[258px] rounded-full bg-[#354BCA] blur-[196.15px] mix-blend-plus-lighter" />
        <div className="absolute left-[-33px] top-[389px] h-[274px] w-[274px] rounded-full bg-[#354BCA] blur-[196.15px] mix-blend-plus-lighter" />
        <div className="absolute left-[-25px] top-[389px] h-[274px] w-[274px] rounded-full bg-[#354BCA] blur-[196.15px] mix-blend-plus-lighter" />
        <div className="absolute left-[190px] top-[358px] h-[274px] w-[274px] rounded-full bg-[#468DEA] blur-[196.15px] mix-blend-plus-lighter" />

        <div
          className="absolute left-1/2 top-[288.18px] flex h-40 w-[513.33px] -translate-x-1/2 items-center text-[61.73px] font-semibold uppercase leading-[130%] tracking-[-0.04em] text-white"
          style={{ fontFamily: "'Oswald', sans-serif" }}
        >
          Специально <br />
          для тебя!
        </div>
      </div>
    </div>
  );
}

function PosterCard({ item }) {
  return (
    <Link to={item.href} className="group relative block h-[470px] w-[287px] overflow-hidden rounded-xl shadow-[0px_90px_36px_rgba(0,0,0,0.01),0px_50px_30px_rgba(0,0,0,0.05),0px_22px_22px_rgba(0,0,0,0.09),0px_6px_12px_rgba(0,0,0,0.1)]">
      <div className="for-you-angled-poster h-full w-full overflow-hidden bg-[#111111]">
        <img
          className="h-full w-[104%] max-w-none -translate-x-[2%] object-cover object-center"
          src={item.img}
          alt={item.title}
          draggable="false"
        />
        <div className="absolute inset-0 flex items-center justify-center bg-black/40 opacity-0 transition-opacity duration-300 group-hover:opacity-100"><PlayIcon /></div>
      </div>
    </Link>
  );
}

export default function ForYouSection({ items }) {
  return (
    <section className="home-for-you w-full bg-black px-[52px] py-7">
      <div className="jost-s mb-[14px] text-[32px] font-semibold uppercase text-white">
        Специально для тебя
      </div>
      <div className="flex w-full items-start gap-[10px] overflow-hidden">
        <ForYouLeadCard />
        <div className="min-w-0 flex-1">
          <ScrollRow cardStyle="287px" arrowOffset={0}>
            {items.map((item) => (
              <PosterCard item={item} key={item.id || item.title} />
            ))}
          </ScrollRow>
        </div>
      </div>
    </section>
  );
}
